import React from 'react';
import { Link } from 'react-router-dom';
import { User, Package, LogIn } from 'lucide-react';

const AccountPage = () => (
  <div className="bg-black text-white min-h-[70vh]">
    <div className="max-w-[800px] mx-auto px-4 lg:px-8 py-16">
      <User className="text-[#909090] mb-4" size={36} />
      <h1 className="text-4xl font-bold mb-3">My Account</h1>
      <p className="text-zinc-400 mb-10">Login or create a new account to track your orders.</p>

      <div className="grid md:grid-cols-2 gap-6">
        <form className="bg-zinc-950 border border-zinc-900 rounded p-6">
          <h2 className="font-semibold mb-4 flex items-center gap-2"><LogIn size={18}/> Login</h2>
          <input type="email" placeholder="Email" className="w-full bg-black border border-zinc-800 text-white px-4 py-2.5 rounded text-sm mb-3 focus:outline-none focus:border-[#909090]" />
          <input type="password" placeholder="Password" className="w-full bg-black border border-zinc-800 text-white px-4 py-2.5 rounded text-sm mb-4 focus:outline-none focus:border-[#909090]" />
          <button type="button" className="w-full bg-[#909090] hover:bg-[#a8a8a8] text-black font-semibold py-2.5 rounded transition-colors">Sign in</button>
        </form>

        <div className="bg-zinc-950 border border-zinc-900 rounded p-6">
          <h2 className="font-semibold mb-4 flex items-center gap-2"><Package size={18}/> Track an order</h2>
          <p className="text-zinc-400 text-sm mb-4">Already placed an order? Track it instantly with your order ID.</p>
          <Link to="/track" className="inline-block w-full text-center border border-[#909090] text-[#909090] hover:bg-[#909090] hover:text-black font-semibold py-2.5 rounded transition-colors">
            Track order
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default AccountPage;
